<template>
  <!-- preloader start -->
  <div id="preloader">
    <div id="status">&nbsp;</div>
  </div>
  <!-- preloader end -->
</template>

<script>
export default {
  name: "Preloader",
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
